import { render, staticRenderFns } from "./VxJson.vue?vue&type=template&id=91b37f32&scoped=true&"
import script from "./VxJson.vue?vue&type=script&lang=js&"
export * from "./VxJson.vue?vue&type=script&lang=js&"
import style0 from "./VxJson.vue?vue&type=style&index=0&id=91b37f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b37f32",
  null
  
)

export default component.exports